<script setup lang="ts">
    import type { TextWidgetData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    /**
     * Text Widget
     * renders normal text or as a hint
     */
    const props = defineProps<IWidgetProps<TextWidgetData>>();
    const { data } = useWidget(props);

    // validate data here and perform additional async calls if required
</script>
<template>
    <!-- removed class="cms-text-widget" becasue of root element expected on TextBlock casuing hydration issue -->
    <!-- TODO: Test TextBlock to see if component can have 1 root -->
    <cms-text-block
        :markup="data.text"
        :display="data.display" />
</template>
